<template>
  <div class="invoiceContent clearfix">
    <div v-if="!is_loading" class="topBox mb-3">
      <h5 class="biaoti">
        {{info.invoiceFrom==='1'?'个人':'企业'}}申请
        <span class="badge" :class="{'badge-danger':info.is_state==='1','badge-success':info.is_state==='2','badge-secondary':info.is_state==='3'}">{{info.is_state==='1'?'处理中':''}}{{info.is_state==='2'?'已完成':''}}{{info.is_state==='3'?'已取消':''}}</span>
      </h5>
      <hr style="border-color: rgba(0, 0, 0, 0.1);">
      <div class="row">
        <div class="col-12 col-md-4">
          <span class="content">编号：</span>{{info.no}}
        </div>
        <div class="col-12 col-md-4">
          <span class="content">类型：</span>{{info.invoiceType==='1'?'电子普通发票':'纸质增值税专用发票'}}
        </div>
        <div class="col-12 col-md-4">
          <span class="content">日期：</span>{{info.addtime_ymd}}
        </div>
        <div class="col-12 col-md-4">
          <span class="content">支付：</span>{{info.payment_proceeds_title && info.tax*1!==0?info.payment_proceeds_title:'免支付'}}
        </div>
        <div class="col-12 col-md-4">
          <span class="content">实付：</span>{{info.currencyType==='1'?'￥':'未知币种'}}{{info.tax}}
        </div>
        <div class="col-12 col-md-4">
          <span class="content">面额：</span>{{info.currencyType==='1'?'￥':'未知币种'}}{{info.totalSum}}
        </div>
        <div v-if="info.trade_no" class="col-12">
          <span class="content">{{info.payment_proceeds_title}}交易号：</span>{{info.trade_no}}
        </div>
      </div>
    </div>
    <div v-if="!is_loading" class="topBox mingxiBox mb-3">
      <div class="row" v-if="!is_loading">
        <div class="col-12">
          <h5>开票明细</h5>
          <p class="content mb-2"><small>— 票据包含的商品内容</small></p>
        </div>
        <div class="col-12">
          <table class="table table-bordered m-0">
            <thead>
            <tr>
              <td class="bg-light" scope="col">编号</td>
              <td class="bg-light" scope="col">商品</td>
              <td class="bg-light" scope="col">面额<small> / 税率</small></td>
              <td class="text-right bg-light" scope="col">税额</td>
            </tr>
            </thead>
            <tbody v-for="(app,index) in goodsArr" :key="index">
            <tr v-for="(apps,indexs) in app" :key="indexs">
              <td class="bg-light" v-if="indexs===0" :rowspan="app.length">
                {{apps.order_no?'NO.'+apps.order_no:apps.bills_no}}
              </td>
              <td>
                {{apps.goods_name}} × {{apps.num*1}}
              </td>
              <td>
                {{info.currencyType==='1'?'￥':''}}{{info.currencyType==='2'?'$':''}}{{apps.price}}<small> / {{apps.tax}}%</small>
              </td>
              <td v-if="apps.taxFree*1===0" class="text-right text-primary">
                {{info.currencyType==='1'?'￥':''}}{{info.currencyType==='2'?'$':''}}{{apps.taxPrice}}
              </td>
              <td class="text-right text-danger" v-else>
                免税点
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-if="!is_loading" class="topBox mb-3">
      <h5>发票抬头</h5>
      <hr style="border-color: rgba(0, 0, 0, 0.1);">
      <div class="row">
        <div v-if="info.invoiceFrom==='2'" class="col-12 col-md-6">
          <span class="content">发票抬头：</span>{{info.headTitle}}
        </div>
        <div v-if="info.invoiceFrom==='2'" class="col-12 col-md-6">
          <span class="content">信用代码：</span>{{info.headCode}}
        </div>
        <div v-if="info.invoiceFrom==='2'" class="col-12 col-md-6">
          <span class="content">开&nbsp;户&nbsp;行&nbsp;：</span>{{info.headBank}}
        </div>
        <div v-if="info.invoiceFrom==='2'" class="col-12 col-md-6">
          <span class="content">银行账号：</span>{{info.headBankcode}}
        </div>
        <div v-if="info.invoiceFrom==='2'" class="col-12 col-md-6">
          <span class="content">注册电话：</span>{{info.headRegisterphone}}
        </div>
        <div v-if="info.invoiceFrom==='2'" class="col-12 col-md-6">
          <span class="content">注册地址：</span>{{info.headRegisteraddress}}
        </div>
        <div v-if="info.invoiceFrom==='1'" class="col-12">
          <span class="content">发票抬头：</span>{{info.headPerson}}
        </div>
        <div class="col-12" v-if="info.invoiceType==='2'">
          <hr class="mt-2 mb-2" style="border-style: dashed">
        </div>
        <div class="col-12 col-md-6" v-if="info.invoiceType==='2'">
          <span class="content">收&nbsp;货&nbsp;人&nbsp;：</span>{{info.expressName}}
        </div>
        <div class="col-12 col-md-6" v-if="info.invoiceType==='2'">
          <span class="content">电话号码：</span>{{info.expressPhone}}
        </div>
        <div class="col-12" v-if="info.invoiceType==='2'">
          <span class="content">收货地址：</span>{{info.expressAddress}}
        </div>
      </div>
    </div>
    <div v-if="(!is_loading && fileArr.length>=1) || (!is_loading && info.content)" class="topBox fapiaoBox mb-3">
      <h5>发票文件</h5>
      <hr style="border-color: rgba(0, 0, 0, 0.1);">
      <div class="row">
        <div class="col-12 mb-3" v-if="info.content">
          <div class="remarkBox">
            <span class="content">开票备注：</span>{{info.content?info.content:'无备注内容...'}}
          </div>
        </div>
        <div class="col-12" v-if="fileArr.length>=1">
          <table class="table table-bordered m-0">
            <thead>
            <tr class="bg-light">
              <td scope="col">电子发票</td>
              <td scope="col"></td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(app,index) in fileArr" :key="index">
              <td>
                {{app.title}}
              </td>
              <td class="text-center text-primary">
                <a class="link text-dark" target="_blank" :href="app.path">【查看】</a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="jiazaiBox" v-if="is_loading">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
// import { EventBus } from '@/util/eventBus';
import resultCommons from '@/util/resultcommons';
import generalMix from '@/util/mix/general';

export default {
  name: 'invoiceContent',
  props:['parameter'],
  mixins: [generalMix],
  data () {
    return {
      info:null,
      goodsArr:[],
      fileArr:[],
      is_loading:true
    }
  },
  methods:{
    // 显示详情
    showProduct(title,imgArr) {
    },
    initData() {
      this.is_loading = true;
      resultCommons.apiInvoiceinfo(this, {token:this.parameter.token}).then((app) => {
        if(app.state === 200){
          this.info = app.data.info;
          this.goodsArr = app.data.goodsArr;
          this.fileArr = app.data.filesArr;
          this.is_loading = false;
        }else{
          this.$message.showMsgBox({
            type: 'warning',
            content: app.message
          });
        }
      });
    }
  },
  components: {
    Multiselect
  },
  created() {
  },
  mounted() {
    this.initData();
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

.invoiceContent {
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  background: #F5F5F7;
  width: 60vw;
  height: 100%;
  overflow-y: auto;
  color: #000000;
  .col-12{
    line-height: 1.8em;
  }
  div.jiazaiBox{
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 50vh;
    .spinner-border{
      width: 3rem;
      height: 3rem;
      color: red;
    }
  }
  div.topBox{
    background: #FFFFFF;
    border-radius: 5px;
    padding:20px 20px;
    box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
    h5.biaoti{
      display: flex;
      justify-content: space-between;
      span{
        padding-top: 5px;
      }
    }
    &.fapiaoBox{
      table{
        table-layout: fixed;
        tr{
          td,th{
            white-space:nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            &:last-child{
              width: 100px;
            }
          }
        }
      }
    }
    &.mingxiBox{
      table{
        table-layout: fixed;
        tr{
          td,th{
            white-space:nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            &:first-child{
              width: 180px;
            }
            &:nth-child(3){
              width: 130px;
            }
            &:nth-child(4){
              width: 80px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .invoiceContent{
    width: 70vw;
  }
}

@media (max-width: 992px) {
  .invoiceContent{
    width: 90vw;
  }
}

@media (max-width: 776px) {
  .invoiceContent{
    width: 90vw;
    padding: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/invoice/Content.vue